import { Card, CardContent, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { jhTheme } from '../../../themeProvider';
import { InternalCustomerMasterData } from '../../BaseController/types/internalContract';

export interface CustomerBoxProps {
  header: string;
  customerMasterData: InternalCustomerMasterData | undefined;
}

const getStyle = (): {
  backgroundColor: string;
  borderRadius: number;
  width: string;
} => {
  return {
    backgroundColor: jhTheme.palette.background.default,
    borderRadius: 0,
    width: '100%',
  };
};

export const CustomerBox = (props: CustomerBoxProps) => {
  const { t } = useTranslation();
  const { customerMasterData, header } = props;

  if (!customerMasterData?.text) {
    return (
      <Card variant="elevation" sx={getStyle()}>
        <CardContent>
          <Typography gutterBottom variant="h4">
            {header}
          </Typography>
          <Typography variant="body1" color="text.secondary">
            {t('dataError')}
          </Typography>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card variant="elevation" sx={getStyle()}>
      <CardContent>
        <Typography gutterBottom variant="h4">
          {header}
        </Typography>
        <Typography variant="body1" color="text.secondary">
          {customerMasterData?.text}
        </Typography>
        <Typography variant="body1" color="text.secondary">
          {customerMasterData?.id}
        </Typography>
        <Typography variant="body1" color="text.secondary">
          {`${customerMasterData?.zipCode} ${customerMasterData?.city}`}
        </Typography>
        <Typography variant="body1" color="text.secondary">
          {customerMasterData?.country}
        </Typography>
      </CardContent>
    </Card>
  );
};
